import ApiClient from '../ApiClient';

class SocialMonitoringSettingsAPI extends ApiClient {
  constructor() {
    super('social_monitoring/setting', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }
}

export default new SocialMonitoringSettingsAPI();
